import { Component, OnInit, } from '@angular/core';


@Component({
  selector: 'app-page3',
  templateUrl: './page3.component.html',
  styleUrls: ['./page3.component.css']
})
export class Page3Component implements OnInit {
 
  constructor() {;
  }

  ngOnInit() {
  }

  
}




// WEBPACK FOOTER //
// ./src/app/registration/page3/page3.component.ts